import { Icon, Loader, Stack, Text } from "@certn/cascadia-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export function OneIDLoader() {
  const [step, setStep] = useState(0);
  const { t } = useTranslation();

  const steps = [
    t("Verifying your documents..."),
    t("Checking your document details..."),
    t("Finalizing verification..."),
    t("Almost done!"),
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setStep((previousStep) =>
        previousStep < steps.length ? previousStep + 1 : steps.length
      );
    }, 2000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack gap="space-12">
      <Stack gap="space-2">
        <Text as="h1" style="form/page-title">
          {t("We're processing your ID")}
        </Text>
        <Text style="form/body-primary" color="text-weak">
          {t("Please stay on this page, it may take a few moments.")}
        </Text>
      </Stack>
      <Stack gap="space-2">
        <Loader type="spinner" height={120} />
        <Stack gap="space-0">
          {steps.map((stepText, index) => {
            const stepReached = index + 1 <= step;
            return (
              <Stack key={index} gap="space-1" orientation="horizontal">
                {stepReached ? (
                  <Icon name="check" color="icon-success" />
                ) : (
                  <Icon name="bullet" type="custom" />
                )}
                <Text
                  style="form/body-secondary"
                  color={stepReached ? "text-success" : "text-weak"}
                >
                  {stepText}
                </Text>
              </Stack>
            );
          })}
        </Stack>
      </Stack>
    </Stack>
  );
}
